module.exports = __webpack_public_path__ + "img/workOrder.0fb8430e.png";